"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstDateOfTheYear = exports.currentYear = void 0;
const date_fns_1 = require("date-fns");
const currentYear = () => (0, date_fns_1.getYear)(new Date());
exports.currentYear = currentYear;
const firstDateOfTheYear = (year, hours = 0, minutes = 0, seconds = 0) => (0, date_fns_1.set)(new Date(), { year, month: 0, date: 1, hours, minutes, seconds });
exports.firstDateOfTheYear = firstDateOfTheYear;
const firstDayOfTheYear = (year) => (0, date_fns_1.getDay)((0, exports.firstDateOfTheYear)(year));
exports.default = firstDayOfTheYear;
//# sourceMappingURL=firstDayOfTheYear.js.map